const SignIn = {

    // PAGE HEADER
    "tagline": "Let's get started",
    "sub_tagline": "One Step Closer to the Event of a Lifetime",

    // FIELDS
    "email": "Email",
    "password": "Password",

    // FOOTER
    "forgot_password": "Forgot your password?",
    "reset": "Reset it",
    "footer_tagline_1": "Don't have an account?",
    "footer_tagline_2": "By continuing, you agree to Arokkiyam",
    "t&c": "terms of service ",
    "and": "and",
    "prv&pol": "privacy policy",

    // TOAST
    "success_add": "Login Successfully!!..",
    "server_error": "Server error!!..",
    "wrong": "Something went wrong!!..",

    // ERROR
    "error_email": "Enter Email",
    "error_password": "Enter Password",

}

export default SignIn;